/* eslint-disable @typescript-eslint/ban-ts-comment */
import './register-service-worker.js'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as Sentry from '@sentry/vue'
import ContextMenu from '@imengyu/vue3-context-menu'
import 'lib-flexible/flexible.js'
import { isProd } from '@remote/api/config'
import vueLongpress from '@remote/plugins/vue-longpress'
import vueObserver from '@remote/plugins/vue-observer'
import statPlugin from '@remote/plugins/stat'
import VueSee from '@remote/plugins/vue-see'
import ClickOutside from '@remote/plugins/vue-click-outside'
import { useVConsole } from '@remote/composable/vconsole'

import { isNativeApp, nativeCall } from '@remote/utils'

import App from './App.vue'
import router from './router'
import { store } from './store'
import pinia from '@remote/store/pinia-instance'

import 'element-plus/dist/index.css'
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'

if (location.protocol === 'http:' && isProd) {
  location.replace(location.href.replace('http:', 'https:'))
}

const { check } = useVConsole()
check()

const app = createApp(App)

app.config.performance = !isProd

app.directive(vueLongpress.name, vueLongpress.action)
app.directive(vueObserver.name, vueObserver.action)
app.directive(VueSee.name, VueSee.directive)
app.directive(ClickOutside.name, ClickOutside.directive)

const requireAll = requireContext => requireContext.keys().map(requireContext)
// @ts-ignore
const req = require.context('./assets/icons', true, /.svg$/)
requireAll(req)

if (isProd) Sentry.init({
  app,
  dsn: 'https://bb1b2caf13734cf1b8aff5ac24241b24@bug-xl9-ssl.xunlei.com/42',
  integrations: [
    // new BrowserTracing({
    //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //   tracingOrigins: ['pan.xunlei.com'],
    // }),
  ],
  tracesSampleRate: 1.0,
})

app.use(router)
app.use(store)
app.use(statPlugin)
app.use(ElementPlus)
app.use(pinia)
app.use(ContextMenu)

app.mount('#app')

// 最开始调一下，提前隐藏头部的时机。头部的颜色在后面第一次获取到isVip时会再设置一次。（App.vue）
if (isNativeApp()) {
  const color = '#DFF1FF'
  nativeCall('configNav', false, '迅雷下载', color)
}